import { Stack } from '@mui/material';
import { Panel } from '@/components/Panel';
import { ProfileHeader } from './components/ProfileHeader';
import { StatBar } from './components/StatBar';
import { stats } from './stats';
import { SkillBadge } from '@/components/SkillBadge';
import { EducationRecord } from './components/EducationRecord';
import { educationRecords } from './education';
import { CertificationBadge } from './components/CertificationBadge';
import { certifications } from './certifications';
import { skills } from './skills';
import avatarImage from '@/assets/headshot.png';

export const AboutPage = () => {
  return (
    <Stack>
      <Stack spacing={3}>
        <Stack direction="row" alignItems="stretch" width="100%" gap={3}>
          <Panel width="60%" title="Operator Profile">
            <ProfileHeader
              name="Jovanni Mosca"
              title="Software Developer"
              location="Washington, DC"
              avatarUrl={avatarImage}
              status="ACTIVE"
            />
          </Panel>

          <Panel width="40%" title="Core Stats">
            <Stack spacing={1}>
              {stats.map((stat) => (
                <StatBar
                  key={stat.label}
                  data-testid={`stat-${stat.label
                    .replaceAll(/[^A-Za-z0-9\s]/g, '')
                    .replaceAll(/\s/g, '-')
                    .toLocaleLowerCase()}`}
                  label={stat.label}
                  value={stat.value}
                  max={stat?.max}
                />
              ))}
            </Stack>
          </Panel>
        </Stack>

        <Stack direction="row" alignItems="stretch" width="100%" gap={3}>
          <Panel title="Active Loadout">
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {skills.map((skill) => (
                <SkillBadge
                  key={skill}
                  data-testid={`skill-${skill
                    .replaceAll(/[^A-Za-z0-9\s]/g, '')
                    .replaceAll(/\s/g, '-')
                    .toLocaleLowerCase()}`}
                  label={skill}
                />
              ))}
            </Stack>
          </Panel>

          <Panel title="Certifications">
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {certifications.map((cert) => (
                <CertificationBadge
                  key={`${cert.label}-${cert?.issuer || 'cert'}`}
                  data-testid={`cert-${cert.label
                    .replaceAll(/[^A-Za-z0-9\s]/g, '')
                    .replaceAll(/\s/g, '-')
                    .toLocaleLowerCase()}`}
                  label={cert.label}
                  issuer={cert?.issuer}
                />
              ))}
            </Stack>
          </Panel>
        </Stack>

        <Panel title="Training Records">
          <Stack spacing={1}>
            {educationRecords.map((record) => (
              <EducationRecord
                key={record.institution + record.degree}
                data-testid={`edu-${record.degree
                  .replaceAll(/[^A-Za-z0-9\s]/g, '')
                  .replaceAll(/\s/g, '-')
                  .toLocaleLowerCase()}`}
                degree={record.degree}
                institution={record.institution}
                focus={record?.focus}
                year={record?.year}
              />
            ))}
          </Stack>
        </Panel>
      </Stack>
    </Stack>
  );
};
